import { useCallback, useEffect, useState } from "react";
import { getPendingFileRequests } from "../utils/firebasefunctions";

// Loads the dashboard's File Requests queue.
//
// This exists because the queue cannot be served from the shared `deals` list:
// a file request is stored as a soft-deleted deal, and that list drops
// soft-deleted rows, so the queue sat permanently empty. See
// utils/fileRequestQueue.js for the full explanation.
//
// `enabled` keeps the read off the wire for roles that never see the queue
// (a plain Agent), since hooks can't be called conditionally.
export function usePendingFileRequests(enabled = true) {
  const [fileRequests, setFileRequests] = useState([]);

  const reload = useCallback(async () => {
    if (!enabled) return;
    const rows = await getPendingFileRequests();
    setFileRequests(rows);
  }, [enabled]);

  useEffect(() => {
    let cancelled = false;
    if (!enabled) {
      setFileRequests([]);
      return undefined;
    }
    getPendingFileRequests().then((rows) => {
      if (!cancelled) setFileRequests(rows);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { fileRequests, reload };
}
